import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {updateInventoryAmount, updateInventoryRequest} from '../../../store/slices/boardSlice';
import s from '../Settings/SettingsBlock.module.css';
import sg from '../../../../styles/index.module.css';

const prepareNumber = (n) => {
    if (n === '') {
        return '0';
    }
    n = n.replace(/ /g, '').replace(/,/g, '.').split('.');
    if (n.length === 0) {
        return '0';
    }
    let leftPart = n[0].substr(0, 10);
    if (n.length === 1) {
        return parseInt(leftPart, 10).toString();
    }
    const rightPart = n[1].substr(0, 6);
    if (leftPart === '') {
        leftPart = 0;
    }
    if (rightPart === '') {
        return parseInt(leftPart, 10).toString();
    }

    return `${parseInt(leftPart, 10)},${rightPart}`;
};

export function Amount({ value, inventoryGuid, hasFullAccess, warehouseId, setNewInventoryLog, updateCost }) {
    const [savedValue, setSavedValue] = useState(prepareNumber(
        String(value).trim().replace('.', ',').replace(/\s/g, '')
    ));
    const [editedValue, setEditedValue] = useState(savedValue.toString());
    const [isFocused, setIsFocused] = useState(false);
    const dispatch = useDispatch();

    const setValue = (e) => {
        e.preventDefault();

        let val;
        if (editedValue.trim() === '') {
            val = '1';
        } else {
            val = prepareNumber(
                String(editedValue).trim().replace('.', ',').replace(/\s/g, '')
            );
        }

        setEditedValue(val.toString());
        if (val === savedValue) {
            return;
        }

        setSavedValue(val.toString());

        val = val || 1;

        dispatch(
            updateInventoryAmount({
                warehouseId,
                inventoryGuid,
                amount: parseFloat(val.replace(',','.').replace(/\s/g, ''))
            })
        );
        dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ 'amount': val }),
                inventoryGuid,
                warehouseId,
            }, (data) => {
                setNewInventoryLog(data.response.logItem);
                updateCost(data.response.cost);
            })
        );
    };

    const displayValue = isFocused ? editedValue : numberFormatter.formatNumber(editedValue, 3);

    return (
        <div className={s.inventoryAmountWrapper}>
            {hasFullAccess && (
                <input
                    data-id="inventory-amount"
                    type="text"
                    className={sg.input}
                    value={displayValue}
                    onFocus={(e) => {
                        setIsFocused(true);
                        e.target.select();
                    }}
                    onBlur={(e) => {
                        setIsFocused(false);
                        setValue(e);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.currentTarget.blur();
                        }
                    }}
                    onChange={(e) => {
                        const { value: newValue } = e.target;
                        const regexp = /^[0-9,.\s]*$/;
                        if (regexp.test(newValue)) {
                            setEditedValue(String(newValue));
                        }
                    }}
                />
            )}
            {!hasFullAccess && <div className={s.valueText}>{displayValue}</div>}
        </div>
    );
}
